import React, { useState, forwardRef, Component } from 'react';
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {APP_COLORS} from "../../common/Constants";
import {faCheck, faXmark} from "@fortawesome/free-solid-svg-icons";
import {find} from "lodash";
// import {useDispatch} from 'react-redux';
// import {denormCompanyUpdate} from "./entityVerificationsSlice";

export const ContactRenderer = forwardRef((props, ref) => {
    const attributeDenormPrefix = props.attributeDenormPrefix;
    const attributeValue = props.value;
    const attributeVerified = props.data[attributeDenormPrefix+'Verified'];
    const attributeInvalidated = props.data[attributeDenormPrefix+'Invalidated'];
    const verifiedIcon = attributeVerified ? <FontAwesomeIcon color={APP_COLORS['green']} icon={faCheck}/> : '';

    const contactString = `${props.data[attributeDenormPrefix+'Honorific'] ? props.data[attributeDenormPrefix+'Honorific'] : ''}
                ${props.data[attributeDenormPrefix+'GivenName'] ? props.data[attributeDenormPrefix+'GivenName']: ''}
                ${props.data[attributeDenormPrefix+'MiddleName'] ? props.data[attributeDenormPrefix+'MiddleName']: ''}
                ${props.data[attributeDenormPrefix+'Surname'] ? props.data[attributeDenormPrefix+'Surname']: ''}
                ${props.data[attributeDenormPrefix+'MaturitySuffix'] ? props.data[attributeDenormPrefix+'MaturitySuffix']: ''}
                ${props.data[attributeDenormPrefix+'ProfessionalSuffix'] ? props.data[attributeDenormPrefix+'ProfessionalSuffix']: ''}`;

    // const

    let isUpdatingCell = false;
    if (props.data._updating && props.data._updating.length > 0) {
        isUpdatingCell = !!find(props.data._updating, _updatingData => _updatingData.attributeDenormPrefix === attributeDenormPrefix);
    }
    // const
    if (isUpdatingCell) {
        return (
            <div style={{
                background: APP_COLORS['gray-400'],
                width: '100%',
                height: '100%',
                display: 'flex',
                alignItems: 'center',
                padding: '0 8px',
                margin: '0 -8px'
            }}>
                ...  {attributeInvalidated? <span><FontAwesomeIcon color={APP_COLORS['red']} icon={faXmark}/><s>{verifiedIcon} {contactString}</s></span>: <span>{verifiedIcon} {contactString}</span>}
            </div>
        );
    }
    return (
        <div>
            {attributeInvalidated? <span><FontAwesomeIcon color={APP_COLORS['red']} icon={faXmark}/><s>{verifiedIcon} {contactString}</s></span>: <span>{verifiedIcon} {contactString}</span>}
        </div>
    );

});
